import { Pipe, PipeTransform } from '@angular/core';

import {
  DISCOUNT_PERIODICITY_LABEL,
  PLURAL_DISCOUNT_PERIODICITY_LABEL
} from '@constants/discount-periodicity-label.constant';
import { PeriodicityEnum } from '@enums/periodicity.enum';

@Pipe({
  name: 'discountPeriodicityLabel',
  standalone: true
})
export class DiscountPeriodicityLabelPipe implements PipeTransform {
  transform(periodicity: PeriodicityEnum, occurences: number): string {
    return occurences > 1
      ? PLURAL_DISCOUNT_PERIODICITY_LABEL[periodicity] ?? ''
      : DISCOUNT_PERIODICITY_LABEL[periodicity] ?? '';
  }
}
